let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gwqaI")).then(() => parcelRequire('gx7xU'));